module.exports = __webpack_public_path__ + "static/media/home.c254ec59.svg";